import {call, put, takeLatest} from 'redux-saga/effects';
import ApiUtil from "src/utils/ApiUtil";
import {
    BULK_PRODUCT_DATA_QUERY_START,
    BulkProductDataQueryStartAction,
    getBulkProductDataQueryFailedAction,
    getBulkProductDataQuerySuccessAction
} from "src/actions/BulkProductSearchAction";


export function* getProductData(action: BulkProductDataQueryStartAction) {
    try {
        // todo add sort
        let parameters: any = {
            keywords: action.keywords,
            countryCode: action.countryCode,
            searchType: action.searchType,
            pageOffset: action.pageOffset,
            filters: action.filter
        };
        // @ts-ignore
        const response = yield call(ApiUtil.postApiWithTimeout, "searchproduct", parameters);
        yield put(getBulkProductDataQuerySuccessAction(response));
    } catch (error) {
        console.error("Call API searchproduct error" + error)
        yield put(getBulkProductDataQueryFailedAction());
        return;
    }
}

export default function* productData() {
    yield takeLatest(BULK_PRODUCT_DATA_QUERY_START, getProductData);
}